import styles from './Statistics.module.css';

export type RateBarProps = { label: string; value: number | null; text: string; tone?: 'brand' | 'warning' };

const PERCENT = 100;

export const RateBar = ({ label, value, text, tone = 'brand' }: RateBarProps) => (
  <div className={styles['rate']}>
    <span className={styles['rateLabel']}>{label}</span>
    <span className={styles['rateTrack']} aria-hidden="true">
      <span
        className={styles['rateFill']}
        data-tone={tone}
        style={{ inlineSize: `${String((value ?? 0) * PERCENT)}%` }}
      />
    </span>
    <strong className={styles['figure']}>{text}</strong>
  </div>
);
